














































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ContactForm } from '@/api';
import { snackModule } from '@/store';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: { ConfirmDialog },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  message: ContactForm | null = null;

  messageDeleteDialog: boolean = false;

  get messageId() {
    return this.$route.params.messageId;
  }

  back() {
    this.$router.back();
  }

  formatDateTime(date: string) {
    return moment(date).format('MMM D, YYYY h:mm a');
  }

  async deleteMessage() {
    if (!this.message) {
      return;
    }
    try {
      await this.message.destroy();
      this.messageDeleteDialog = false;
      this.$router.push({
        name: 'admin-contact',
      });
    } catch (e) {
      // Error
    }
  }

  async mounted() {
    try {
      this.message = (await ContactForm.find(this.messageId)).data;
    } catch (err) {
      // most likely this means not found
      snackModule.showSnackbar('Message not found');
    }
  }
}
